<template lang="pug">
  .text-center.neutral700--text
    verification-icon
    .text-md.font-semibold.mb-2 Enter verification code
    .text-sm.mb-4 We’ve sent a verification code to the customer (+{{ phoneNumber }}). Enter the 4-digit verification code below to redeem the {{ itemText }}.
    .otp-container
      v-otp-input(length="4" :value="value" type="number" @input="$emit('input', $event)")
</template>

<script>
import VerificationIcon from "@/components/marketing/merchantapp/redeem/VerificationIcon.vue";

export default {
  components: {
    VerificationIcon,
  },
  props: {
    value: {
      type: String,
      default: null
    },
    phoneNumber: {
      type: String,
      default: null
    },
    itemText: {
      type: String,
      default: 'offer'
    }
  },
}
</script>

<style scoped>
.otp-container {
  width: 85%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
</style>